import { FC } from "react";
import { AMENITIES_ICONS } from "../../../containers/ListingDetailPages/Common/constant";

interface AmenitiesTagProps {
  name: string;
  className?: string;
  variant?: "default" | "compact" | "modal";
  size?: "sm" | "md" | "lg";
}

const AmenitiesTag: FC<AmenitiesTagProps> = ({
  name,
  className = "",
  variant = "default",
  size = "md"
}) => {
  const getIconFromAmenities = (amenityName: string) => {
    // Use comprehensive AMENITIES_ICONS from constants
    const icon = AMENITIES_ICONS.find(item => item.name.toLowerCase() === amenityName.toLowerCase());
    if (icon) {
      return icon.icon;
    }

    // Fallback to basic icon mapping for common amenities
    const fallbackIcons = [
      { name: "wifi", icon: "la-wifi" },
      { name: "tv", icon: "la-tv" },
      { name: "aria condizionata", icon: "la-fan" },
      { name: "asciugatore", icon: "la-fan" },
      { name: "ventilatore", icon: "la-fan" },
      { name: "asciugacapelli", icon: "la-fan" },
      { name: "lavastoviglie", icon: "la-fan" },
      { name: "prodotti per la cura personale", icon: "la-bath" },
      { name: "scrivania", icon: "la-desktop" },
      { name: "cassaforte", icon: "la-lock" },
      { name: "armadio", icon: "la-tshirt" }
    ];
    const fallbackIcon = fallbackIcons.find(item => item.name.toLowerCase() === amenityName.toLowerCase());
    return fallbackIcon?.icon || 'la-check';
  };

  // Size configurations
  const sizeConfig = {
    sm: {
      icon: "text-2xl",
      text: "text-sm",
      padding: "px-3 py-2",
      spacing: "space-x-2.5"
    },
    md: {
      icon: "text-4xl",
      text: "text-base",
      padding: "px-5 py-3",
      spacing: "space-x-3"
    },
    lg: {
      icon: "text-5xl",
      text: "text-lg",
      padding: "px-6 py-4",
      spacing: "space-x-4"
    }
  };

  // Variant configurations
  const variantConfig = {
    default: {
      container: "rounded-full",
      icon: "text-neutral-600 dark:text-neutral-400",
      text: "text-neutral-700 dark:text-neutral-300"
    },
    compact: {
      container: "rounded-full",
      icon: "text-neutral-600 dark:text-neutral-400",
      text: "text-neutral-700 dark:text-neutral-300"
    },
    modal: {
      container: "",
      icon: "text-neutral-600 dark:text-neutral-400",
      text: "text-neutral-700 dark:text-neutral-300"
    }
  };

  const config = sizeConfig[size];
  const variantStyle = variantConfig[variant];

  return (
    <div
      className={`
        flex items-center justify-center
        ${config.spacing}
        ${config.padding}
        ${variantStyle.container}
        ${className}
      `}
    >
      <i
        className={`
          las ${getIconFromAmenities(name)}
          ${config.icon}
          ${variantStyle.icon}
        `}
      ></i>
      <span
        className={`
          ${config.text}
          ${variantStyle.text}
        `}
      >
        {name}
      </span>
    </div>
  );
};

export default AmenitiesTag;
